<template lang="html">
  <div class="try-video" v-if="image">
    <img :src="image" alt="" class="img-f">
    <video
      v-show="!isTryVideoShow"
      :src="url"
      :style="style"
      ref="video"
      class="try-video-main"
			playsinline="true"
			webkit-playsinline="true"
      controls
      controlsList="nodownload"
    ></video>
    <div class="try-video-cover" v-if="!started && courseType !== 8 && url" @click="click">
      <img src="../assets/images/try-video-button.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: "TryVideo",

  // 'url',
  props: ["image", "isTryVideoShow","url","courseType"],

  data() {
    return {
      started: false,
      // url: "",
    };
  },

  created() {
    // this.url = "http://edu-wps.ks3-cn-beijing.ksyun.com/video_mp4_720/d0827b5b7a2b11eaa32a6805caa3e7081586413918878/d0827b5b7a2b11eaa32a6805caa3e7081586413918878.mp4";
  },

  computed: {
    style() {
      return {
        opacity: Number(this.started),
      };
    },
    video() {
      return this.$refs.video;
    },
  },

  methods: {
    click() {
      this.started = true;
      this.video.play();
    },
  },
};
</script>

<style lang="scss">
@charset "UTF-8";
@import "../style/main";

.try-video {
  @include square(100%, $g-player);
  position: relative;
  &-cover {
    @include absolute("tlwh");
    background-color: rgba(0, 0, 0, 0.4);
    @include center-box();
    z-index: 10;
    img {
      display: block;
      @include square(240, 70);
    }
  }
  &-main {
    @include absolute("tlwh");
    z-index: 10;
    // opacity: 0;
    &::-internal-media-controls-download-button {
      display: none;
    }

    &::-webkit-media-controls-enclosure {
      overflow: hidden;
    }

    &::-webkit-media-controls-panel {
      width: calc(100% + 30px);
    }
  }
}
</style>
